import React, { useState, useEffect } from 'react';

const EditarLaborUM = (p) => {
    const inputs = p.inputs;
    const [modif, setmodif] = useState(p.data ? { ...p.data } : { id: null, nombre: '', des: '' });
    const changeValue = (event) => {
        let { name, value } = event.target;
        setmodif({ ...modif, [name]: value });
    }

    const update = async (update, deleteReg = false) => {
        let data = { ...modif };
        data.tipo = p.type;
        if (await p.update(data, update, deleteReg)) p.close();
    }

    return (
        <div className='vw-100 vh-100 blur-s bg-white5' style={{ position: "fixed", top: 0, left: 0, zIndex: 10, }}>

            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='bw-1000 bg-white2 p-2 pt-3 pb-3 blur-xxl round-s shadow-multi mt-5'>

                    <div className='w-100 text-end' style={{ position: "sticky", left: 0, top: 0, zIndex: 15 }}>
                        <button className='btn btn-danger shadow me-2 round-xl border border-2 scale-continue-05' onClick={p.close}>Cerrar</button>
                    </div>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        {!p.data && <>
                            <div className='bw-300 mt-2 mb-5 text-bold border-bottom  border-warning  h3'>Nuevo registro</div>
                            <div className='w-100'></div>
                        </>}
                        {
                            inputs.map((input, i) =>
                                <div key={input.name} className={`form-group bw-${input.size ?? 300}`}>
                                    <label className='text-bold w-100 text-start ps-2'>{input.label}</label>
                                    <input
                                        type={input.type}
                                        className='form-control shadow border'
                                        autoComplete='off'
                                        value={modif[input.name]}
                                        onChange={changeValue}
                                        disabled={input.disable}
                                        name={input.name} />
                                </div>
                            )
                        }
                        <div className='w-100 mt-4 mb-3 text-center'>
                            <div className='row justify-content-evenly w-100 m-0 p-0'>
                                {modif.id && <button className='btn btn-danger bg-red3 text-white shadow text-bold border border scale-025 round-xxl bw-100'
                                    onClick={() => { update(false, true) }}
                                >Eliminar</button>}
                                {
                                    p.data && <button className='btn btn-warning shadow text-red4 text-bold border border scale-025 ps-5 pe-5 round-xxl bw-300'
                                        onClick={() => { update(false) }}
                                    >Guardar como nuevo registro</button>
                                }
                                <button className='btn btn-warning shadow text-red4 text-bold border border scale-025 ps-5 pe-5 round-xxl bw-200'
                                    onClick={() => { update(p.data ? true : false) }}
                                >{p.data ? "Guardar cambios" : "Crear registro"}</button>
                            </div>

                        </div>
                    </div>
                </div>


            </div>
        </div>
    )
}

export default EditarLaborUM;